import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            mx: 'auto',
            width: '100%',
            textAlign: 'center',
            px: {base: remCalc(16), md: remCalc(24), xl: 0},
            pt: {base: remCalc(16), xl: 0},
            pb: {base: remCalc(40), xl: 0},
            bgColor: {base: 'background.brand', xl: 'transparent'},
        },
        content: {
            '.swiper-pagination-bullet-active': {
                textDecoration: 'underline',
                textUnderlineOffset: remCalc(4),
            },
            '.swiper-pagination-bullet': {
                background: 'none',
                w: 'auto',
                h: 'auto',
                m: '0 !important',
                cursor: 'pointer',
            },
            '.swiper-slide-active .swiper-button': {
                display: 'block',
            },
            '.swiper-button-prev': {
                left: '8.33%',
                transform: 'translate(-50%, -50%)',
            },
            '.swiper-button-next': {
                right: '8.33%',
                transform: 'translate(50%, -50%)',
            },

            '.cs-swiper-mobile': {
                display: 'flex',
                flexDirection: 'column-reverse',
            },

            '#mobile-pagination-container': {
                msOverflowStyle: 'none',
                scrollbarWidth: 'none',
                overflowX: {base: 'auto', md: 'hidden'},
            },
            '#mobile-pagination-container::-webkit-scrollbar': {
                display: 'none',
            },
        },
        pagination: {
            position: 'absolute',
            bottom: `min(7%, ${remCalc(78)}) !important`,
            w: '100%',
            zIndex: 2,
            justifyContent: 'center',
            gap: remCalc(46),
            textStyle: 'body-small',
            fontWeight: 'bold',
            color: 'text.inverse',
        },
        mobilepagination: {
            color: 'text.inverse',
            textStyle: 'body-small',
            fontWeight: 'bold',
            pt: {base: remCalc(24), md: remCalc(20)},
            pb: remCalc(24),
            justifyContent: {base: 'flex-start', md: 'space-between', lg: 'center'},
            gap: remCalc(46),
            minW: {base: 'max-content', md: 'unset'},
        },
        slide: {
            position: 'relative',
        },
        slidemain: {
            display: {base: 'flex', xl: 'block'},
            flexDirection: 'column',
            gap: remCalc(24),
        },
        image: {
            h: '100%',
            minW: remCalc(343),
            minH: remCalc(240),
        },
        textblock: {
            flexDirection: 'column',
            px: {base: 0, md: `min(12%, ${remCalc(219)})`},
            bgColor: {xl: 'rgba(0, 0, 0, 0.3)'},
            position: {xl: 'absolute'},
            gap: {base: remCalc(24), xl: remCalc(40)},
            top: 0,
            bottom: 0,
            justifyContent: 'center',
            alignItems: 'center',
            w: '100%',
            color: 'text.inverse',
        },
        textblockheadingcontainer: {
            flexDirection: 'column',
            gap: remCalc(24),
        },
        label_paragraph: {
            textTransform: 'uppercase',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        textblocktitle: {
            textStyle: 'display-large',
            fontWeight: 'medium',
        },
        textblockbodycopy: {
            textStyle: {base: 'body-large', xl: 'body-xlarge'},
            fontWeight: 'normal',
        },
        chevronIcon: {
            w: 'iconsSize.xlarge',
            h: 'iconsSize.xlarge',
            backgroundColor: 'background.default',
            borderRadius: '50%',
            cursor: 'pointer',
            zIndex: 2,
            position: 'absolute',
            top: '50%',
        },
        cta: {
            textDecoration: 'none !important',
            minW: {base: '100%', md: 'unset'},
        },
    },
    variants: {
        black: {
            container: {
                bgColor: {base: 'background.dark', xl: 'transparent'},
            },
        },
        grey: {
            container: {
                bgColor: {base: 'background.light', xl: 'transparent'},
            },
            mobilepagination: {
                color: 'text.default',
            },
            textblock: {
                color: {base: 'text.default', xl: 'text.inverse'},
            },
        },
    },
}
